module.exports = __webpack_public_path__ + "static/img/login-bg.78687e05.png";